import { Injectable } from "@angular/core";
import { Store } from '@ngrx/store';
import { Actions } from '@ngrx/effects';
import { Observable } from 'rxjs';

import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';

import { UrlService } from '@core/services/url/url.service';
import * as CFormsSearch from '@core/custom-forms/models/field-search.model';

import * as Objects from '@core/objects';
import * as fromState from '@core/store/state/custom-forms/custom-forms.state';
import * as fromActions from '@core/store/state/custom-forms/custom-forms.actions';
@Injectable({
    providedIn: 'root'
})
export class CoreCustomFormsFiltersService {

    constructor(private url : UrlService, private store: Store<fromState.CustomForms>, private actions$: Actions,  protected http: HttpClient) {}

    loadFilters = () => this.store.dispatch( new fromActions.LoadFilters());

    loadLabelsFilter = () => this.store.dispatch( new fromActions.LoadFilterLabels());
    
    selectInitializedFilters = (): Observable<boolean> => this.store.select(fromState.customFormsFiltersInitializedSelector);

    selectInitializedLabelsFilter = (): Observable<boolean> => this.store.select(fromState.customFormsLabelsFiltersInitializedSelector);
    
    selectLabels = ():  Observable<CFormsSearch.SearchAvailableFilters> => this.store.select(fromState.availableFilterLabelsSelector);

    selectStatus = ():  Observable<CFormsSearch.SearchAvailableFilters> => this.store.select(fromState.availableFilterStatusSelector);

    // selectOwners = ():  Observable<Search.SearchAvailableFilters> => this.store.select(fromState.availableFilterOwnersSelector);
}

@Injectable({
    providedIn: 'root'
})
export class CoreCustomFormsService {
    constructor(private url : UrlService, private store: Store<fromState.CustomForms>, private actions$: Actions,  protected http: HttpClient) {}

    loadCategories = () => this.store.dispatch(new fromActions.LoadCategories());

    loadUsers = () => this.store.dispatch(new fromActions.LoadUsers());

    setTerm = (fieldId: string, term: string) => this.store.dispatch(new fromActions.SetSearchTerm(fieldId,term));

    applyFilters = (fieldId: string, filters: CFormsSearch.SearchAppliedFilter[]) => this.store.dispatch( new fromActions.ApplySearchFilter(fieldId,filters));

    removeFilter = (fieldId: string, filter: CFormsSearch.SearchAppliedFilter) => this.store.dispatch( new fromActions.RemoveSearchFilter(fieldId,filter));

    selectInitializedCategories = (): Observable<boolean> => this.store.select(fromState.customFormsStartingCategoriesSelector);

    selectInitializedUsers = (): Observable<boolean> => this.store.select(fromState.customFormsStartingUsersSelector);

    selectCategories = (): Observable<Objects.LabelsGroup[]> => this.store.select(fromState.categoriesSelector);

    selectUsers = (): Observable<Objects.User[]> => this.store.select(fromState.usersSelector);

    loadResults = (fieldId: string) => this.store.dispatch( new fromActions.SearchArtworks(fieldId));

    selectArtworkResults = (fieldId: string): Observable<Objects.Version[]> => this.store.select(fromState.artworkResultsSelector(fieldId));

    clearArtworkResults = (fieldId: string) => this.store.dispatch(new fromActions.CleanArtworks(fieldId));

    selectResultStatus = (fieldId: string) : Observable<number> => this.store.select(fromState.resultStatusSelector(fieldId));

    
}